import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomDownloadsStateType {
    readonly isLoading: boolean;
    readonly isSuccess: boolean;
    readonly downloadables: { [key: string]: any };
}

export type CustomDownloadsState = Readonly<CustomDownloadsStateType>;

export const initialCustomDownloadsState: CustomDownloadsState = {
    isLoading: false,
    isSuccess: true,
    downloadables: {},
};

export const customDownloadsReducer = createTypedReducer(initialCustomDownloadsState, {
    "Custom/Downloads/SetDownloadLoading": (
        draft: Draft<CustomDownloadsState>,
        { isLoading, isSuccess }: { isLoading: boolean; isSuccess: boolean },
    ) => ({
        ...draft,
        isLoading,
        isSuccess,
    }),
    "Custom/Downloads/SetDownloadablesByType": (
        draft: Draft<CustomDownloadsState>,
        { documentType, documentId, value }: { documentType: string; documentId: string; value: any },
    ) => ({
        ...draft,
        downloadables: {
            ...draft.downloadables,
            [documentType]: {
                [documentId]: value,
            },
        },
    }),
});
